import React, { Fragment } from "react";
import Field from "../Field";
import TextFieldStyles from "../Input/TextField/TextField.module.css";
import { labelName } from "../../utils";

export default function FieldGroup({ ...props }) {
  const { field_items, field_label, displayLabel, field_type, is_required, initialValue  } = props;
  const items = field_items ? field_items.map((item)=>{
    item.is_required = is_required;
    return item;
  }):[];

  function getInitialValue(field) {
    if (Array.isArray(initialValue)) {
      return initialValue.find((val) => {
        return val.name === field.field_label;
      })?.value;
    }
    if (typeof initialValue === "object" && initialValue !== null) {
      return initialValue[field.field_label]?.value;
    }
    return undefined;
  }
  return (
    <div className="field-group">
      <h3 className={TextFieldStyles.fieldGroupTitle}>{labelName(displayLabel || field_label)}</h3>
      <div className="field-group-list">
        {items &&
          items.map((field, index) => (
            <Fragment key={`fied${index}`}>
              <Field field={{ ...field, initialValue: getInitialValue(field) }} parent={field_type}  />
            </Fragment>
          ))}
      </div>
    </div>
  );
}
